// extracted by mini-css-extract-plugin
export default {"rangeSelect":"TenantSelection_rangeSelect__fiJdA"};